import TicketStack from 'components/dashboard/entries-and-stats/TicketStack';
import { PromoCodeEntry } from 'components/enter/order-summary/PromoCodeEntry';
import ExpandySection from 'components/ExpandySection';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import ChevronLeft15 from '../svg/ChevronLeft15.svg';
import ShoppingCart from '../svg/ShoppingCart.svg';
import styles from './HeaderOrderSummary.module.css';
import OrderSummaryCosts from './OrderSummaryCosts';
import OrderSummaryRows from './OrderSummaryRows';

interface Props {}

const HeaderOrderSummary = observer((props: Props) => {
  const enterStore = useEnterStore();
  const [promoOpen, setPromoOpen] = useState(false);
  const [ticketsExpanded, setTicketsExpanded] = useState(false);

  return (
    <ExpandySection
      containerClassName={styles.container}
      expandedContainerClassName={styles.containerExpanded}
      expandButtonAlignment="right"
      headerContent={
        <div className={styles.header}>
          <ShoppingCart className={styles.cart} />
          <ChevronLeft15 className={styles.chevron} />
        </div>
      }
    >
      <div className={styles.content}>
        <h3 className={styles.heading + ' aboutUsTypographyHeaderMedium'}>
          Your order
        </h3>
        <hr />
        <div className={styles.entryContainer}>
          <TicketStack
            entries={enterStore.lines}
            withLoadingSkeleton={false}
            expanded={ticketsExpanded}
            hideExpandButton
          />
          <div className={styles.buttonContainer}>
            <button
              className={
                styles.promoLink + ' ' + (promoOpen ? styles.promoLinkOpen : '')
              }
              onClick={() => setPromoOpen((x) => !x)}
            >
              Got a code?
            </button>
            {enterStore.lines.length > 1 && (
              <button
                className={styles.expandLink}
                onClick={() => setTicketsExpanded((x) => !x)}
              >
                {ticketsExpanded ? 'Collapse' : 'Expand'}
              </button>
            )}
          </div>
          {promoOpen && (
            <div className={styles.promoPanel}>
              <PromoCodeEntry />
            </div>
          )}
        </div>
        <hr />
        <OrderSummaryRows showDays />
        <div className={styles.costsContainer}>
          <OrderSummaryCosts />
        </div>
        <span className="aboutUsTypographyBodySmall">
          <strong className={styles.cancelText}>👋 Cancel anytime 👋</strong>
        </span>
      </div>
    </ExpandySection>
  );
});

export default HeaderOrderSummary;
